import { useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Flex, Input } from '#atoms';
import useSearchEducationQuery from '#hooks/queries/onboard/useSearchEducationQuery';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import Education from './components/Education';
import NotFoundEducation from './components/NotFoundEducation';
import { useEducationFormState } from './OnBoardSearchEducation.hooks';

export function OnBoardSearchEducation() {
  const [name, setName] = useState('');
  const { educationFormState, setEducationFormState } = useEducationFormState();
  const { data: educations } = useSearchEducationQuery(name);
  const navigate = useNavigate();

  const handleChoose = ({
    name,
    educationIssuerClassId,
    institution
  }: typeof educationFormState) => {
    setEducationFormState({ educationIssuerClassId, institution, name });
    navigate(-1);
  };

  return (
    <>
      <PrevHeaderBarWithTitleTemplate
        title="교육"
        hasBorder={false}
        ContainerStyle={{ position: 'relative' }}
        defaultBackground
      >
        <Wrapper>
          <Input
            labelText="교육명"
            required
            type="text"
            showDeleteButton
            value={name}
            onChange={v => setName(v as string)}
          />
          <div style={{ height: '32px' }} />
          {name &&
            (educations && educations.length > 0 ? (
              <SearchList direction="column" gap={24}>
                {educations.map(education => (
                  <Education
                    key={education.educationIssuerClassId}
                    title={education.name}
                    description={''}
                    handleChoose={handleChoose.bind(null, education)}
                  />
                ))}
              </SearchList>
            ) : (
              <NotFoundEducation name={name} />
            ))}
        </Wrapper>
      </PrevHeaderBarWithTitleTemplate>
    </>
  );
}

const Wrapper = styled.section`
  padding: 20px;
`;

const SearchList = styled(Flex)``;
